export const sv = {
  notFound: 'Bokning hittades inte',
  back: 'Tillbaka',
  unknownCustomer: 'Okänd kund',
  booking: 'Bokning',
  bookingNumber: 'Bokning #{id}',
  bookingInfo: 'Bokningsinformation',
  service: 'Tjänst',
  estimatedTime: 'Uppskattad tid',
  price: 'Pris',
  paymentStatusLabel: 'Betalstatus',
  payAwaiting: 'Inväntar betalning',
  payPaid: 'Betald',
  payFailed: 'Misslyckad',
  payRefunded: 'Återbetald',
  paymentMethodLabel: 'Betalningsmetod',
  payAtGarage: 'Betalas på plats',
  payKlarna: 'Klarna',
  customerNote: 'Kundanteckning',
  cancellationReasonLabel: 'Avbokningsanledning',
  workDone: 'Utfört arbete',
  workOrder: 'Arbetsorder',
  saveWorkOrder: 'Spara arbetsorder',
  saving: 'Sparar…',
  total: 'Totalt',
  workOrderHint: 'Raderna styr vad jobbet kostar. Kunden ser ändringen direkt.',
  workOrderPaidHint: 'Betalningen är redan igångsatt — nya rader ändrar inte beloppet kunden debiteras.',
  workNotesPlaceholder: 'Beskriv vad som utfördes, delar som bytts, observationer…',
  saveNote: 'Spara anteckning',
  noteVisibleHint: 'Anteckningen visas för kunden i appen efter att jobbet är slutfört.',
  photos: 'Bilder',
  imageAlt: 'Bild {n}',
  noPhotos: 'Inga bilder uppladdade än',
  uploading: 'Laddar upp…',
  addPhotos: 'Lägg till bilder',
  photosAfterPayment: 'Bilder kan laddas upp när betalning har bekräftats.',
  photosVisibleHint: 'Bilderna visas för kunden i appen.',
  actions: 'Åtgärder',
  cancellationRequestedNote: 'Kunden har begärt avbokning och inväntar återbetalning. Godkänn för att återbetala kunden och avboka jobbet.',
  reasonLabel: 'Anledning: {reason}',
  approveCancellation: 'Godkänn avbokning & återbetalning',
  paymentNotConfirmedNote: 'Betalning har inte bekräftats än. Jobbet kan inte bekräftas eller slutföras förrän betalning är mottagen.',
  confirmBooking: 'Bekräfta bokning',
  markComplete: 'Markera som klar',
  cancel: 'Avboka',
  noActions: 'Inga åtgärder tillgängliga',
  customer: 'Kund',
  name: 'Namn',
  phone: 'Telefon',
  email: 'E-post',
  vehicle: 'Fordon',
  makeModel: 'Märke & modell',
  year: 'Årsmodell',
  regNumber: 'Registreringsnummer',
  payment: 'Betalning',
  status: 'Status',
  statusPendingPayment: 'Inväntar betalning',
  statusPending: 'Väntar',
  statusConfirmed: 'Bekräftad',
  statusCompleted: 'Slutförd',
  statusCancelled: 'Avbokad',
  statusPendingCancellation: 'Avbokning inväntar',
  amount: 'Belopp',
  cancelJobTitle: 'Avboka jobb',
  cancelButton: 'Avbryt',
  confirmCancellation: 'Bekräfta avbokning',
  reason: 'Anledning',
  selectReason: 'Välj anledning…',
  additionalInfo: 'Ytterligare information',
  optional: '(valfritt)',
  describeSituationPlaceholder: 'Beskriv situationen om nödvändigt…',
  cancellationNotifHint: 'Kunden får en notis om avbokningen via appen.',
  aftercheckTitle: 'Efterkontroll besiktning',
  aftercheckOfferHint: 'Erbjud kunden att du kör bilen till efterkontrollen. Kunden godkänner i appen och avgiften läggs till på arbetsordern.',
  aftercheckOffer: 'Erbjud efterkontroll ({price})',
  aftercheckWaiting: 'Väntar på kundens svar på erbjudandet om efterkontroll.',
  aftercheckDeclined: 'Kunden tackade nej till efterkontroll. Du kan fråga igen.',
  aftercheckApproved: 'Kunden har godkänt efterkontroll för {price}. Avgiften ligger på arbetsordern.',
  aftercheckComplete: 'Efterkontroll klar – meddela kunden',
  aftercheckDone: 'Efterkontrollen är klar och kunden är meddelad att bilen kan hämtas.',
  aftercheckPriceHint: 'Priset ändrar du under Profil.',
}

export const en: typeof sv = {
  notFound: 'Booking not found',
  back: 'Back',
  unknownCustomer: 'Unknown customer',
  booking: 'Booking',
  bookingNumber: 'Booking #{id}',
  bookingInfo: 'Booking details',
  service: 'Service',
  estimatedTime: 'Estimated time',
  price: 'Price',
  paymentStatusLabel: 'Payment status',
  payAwaiting: 'Awaiting payment',
  payPaid: 'Paid',
  payFailed: 'Failed',
  payRefunded: 'Refunded',
  paymentMethodLabel: 'Payment method',
  payAtGarage: 'Pay at the garage',
  payKlarna: 'Klarna',
  customerNote: 'Customer note',
  cancellationReasonLabel: 'Cancellation reason',
  workDone: 'Work performed',
  workOrder: 'Work order',
  saveWorkOrder: 'Save work order',
  saving: 'Saving…',
  total: 'Total',
  workOrderHint: 'These rows set what the job costs. The customer sees the change right away.',
  workOrderPaidHint: 'Payment is already under way — new rows do not change the amount the customer is charged.',
  workNotesPlaceholder: 'Describe what was done, parts replaced, observations…',
  saveNote: 'Save note',
  noteVisibleHint: 'The note is shown to the customer in the app after the job is completed.',
  photos: 'Photos',
  imageAlt: 'Image {n}',
  noPhotos: 'No photos uploaded yet',
  uploading: 'Uploading…',
  addPhotos: 'Add photos',
  photosAfterPayment: 'Photos can be uploaded once payment has been confirmed.',
  photosVisibleHint: 'The photos are shown to the customer in the app.',
  actions: 'Actions',
  cancellationRequestedNote: 'The customer has requested cancellation and is awaiting a refund. Approve to refund the customer and cancel the job.',
  reasonLabel: 'Reason: {reason}',
  approveCancellation: 'Approve cancellation & refund',
  paymentNotConfirmedNote: 'Payment has not been confirmed yet. The job cannot be confirmed or completed until payment is received.',
  confirmBooking: 'Confirm booking',
  markComplete: 'Mark as done',
  cancel: 'Cancel',
  noActions: 'No actions available',
  customer: 'Customer',
  name: 'Name',
  phone: 'Phone',
  email: 'Email',
  vehicle: 'Vehicle',
  makeModel: 'Make & model',
  year: 'Year',
  regNumber: 'Registration number',
  payment: 'Payment',
  status: 'Status',
  statusPendingPayment: 'Awaiting payment',
  statusPending: 'Pending',
  statusConfirmed: 'Confirmed',
  statusCompleted: 'Completed',
  statusCancelled: 'Cancelled',
  statusPendingCancellation: 'Cancellation pending',
  amount: 'Amount',
  cancelJobTitle: 'Cancel job',
  cancelButton: 'Cancel',
  confirmCancellation: 'Confirm cancellation',
  reason: 'Reason',
  selectReason: 'Select a reason…',
  additionalInfo: 'Additional information',
  optional: '(optional)',
  describeSituationPlaceholder: 'Describe the situation if necessary…',
  cancellationNotifHint: 'The customer is notified about the cancellation via the app.',
  aftercheckTitle: 'Re-inspection (efterkontroll)',
  aftercheckOfferHint: 'Offer to drive the car to the re-inspection. The customer approves in the app and the fee is added to the work order.',
  aftercheckOffer: 'Offer re-inspection ({price})',
  aftercheckWaiting: 'Waiting for the customer to answer the re-inspection offer.',
  aftercheckDeclined: 'The customer declined the re-inspection. You can ask again.',
  aftercheckApproved: 'The customer approved the re-inspection for {price}. The fee is on the work order.',
  aftercheckComplete: 'Re-inspection done – notify the customer',
  aftercheckDone: 'The re-inspection is done and the customer has been told the car is ready.',
  aftercheckPriceHint: 'Change the price under Profile.',
}
